var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"channel-list-container"},_vm._l((_vm.list),function(item){return _c('channelItem',{key:item.id,attrs:{"item":item},on:{"update:item":function($event){item=$event},"toDetail":_vm.toDetailPage}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }